import { useState } from 'react'
import { CalendarRange } from 'lucide-react'

const PRESETS = [7, 14, 30, 60, 90, 180, 365]

export interface DateWindow {
  days: number | null
  from: string | null
  to: string | null
}

// Returns the query params that reproduce the current window on navigation.
export function windowParams(w: DateWindow): Record<string, string | number | undefined> {
  return w.days ? { days: w.days } : { from: w.from ?? undefined, to: w.to ?? undefined }
}

export function windowLabel(w: DateWindow): string {
  if (w.days) return `janela ${w.days}d`
  const fmt = (d: string | null) => (d ? d.split('-').reverse().slice(0, 2).join('/') : '…')
  return `${fmt(w.from)} – ${fmt(w.to)}`
}

// Preset day windows + free date range, shared by the eval pages.
export default function EvalDateFilter({ window: w, onChange }: {
  window: DateWindow
  onChange: (params: Record<string, string | number | undefined>) => void
}) {
  const [rangeOpen, setRangeOpen] = useState(!w.days)
  const [from, setFrom] = useState(w.from ?? '')
  const [to, setTo] = useState(w.to ?? '')

  return (
    <div className="flex flex-wrap items-center gap-2">
      <select
        className="rounded-md border bg-background px-2 py-1.5 text-sm"
        value={w.days ?? ''}
        onChange={(e) => {
          if (!e.target.value) { setRangeOpen(true); return }
          setRangeOpen(false)
          onChange({ days: Number(e.target.value), from: undefined, to: undefined })
        }}
      >
        {PRESETS.map((d) => <option key={d} value={d}>{d} dias</option>)}
        <option value="">intervalo…</option>
      </select>
      {rangeOpen && (
        <form
          className="flex items-center gap-1.5"
          onSubmit={(e) => {
            e.preventDefault()
            if (from) onChange({ from, to: to || undefined, days: undefined })
          }}
        >
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)}
                 className="rounded-md border bg-background px-2 py-1 text-sm" required />
          <span className="text-xs text-muted-foreground">até</span>
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)}
                 className="rounded-md border bg-background px-2 py-1 text-sm" />
          <button type="submit" className="inline-flex items-center gap-1 rounded-md border px-2 py-1.5 text-sm hover:bg-accent">
            <CalendarRange className="h-3.5 w-3.5" /> Aplicar
          </button>
        </form>
      )}
    </div>
  )
}
